import React, { useImperativeHandle, useRef, forwardRef } from "react";
import clsx from "clsx";
import { Card, Box, Typography, CheckboxField } from "@curves/ui-base";
import { refIsRequiredError } from "@util/utils";
import OrderCartList from "@icoach/accountBook/createOrder/components/OrderCartList";

/**
 * 批次智能訂單購物車組件
 * 用於顯示批次扣款的智能月費訂單
 *
 * 注意事項：
 * - 此訂單的收款對象是總部，不是店鋪
 * - 此訂單不計入店鋪現場收入的 orderTotal
 * - 智能月費的扣款由系統後台自動批次處理
 * - 智能月費項目為只讀模式，不可編輯或刪除
 *
 * @param {Object} props
 * @param {string} [props.className] - 自定義樣式類名
 * @param {Array} props.deviceOrderCartItems - 智能月費購物車項目陣列（從 useDeviceOrderFeeSync 傳入）
 * @returns {JSX.Element}
 */
const BatchDeviceOrderCart = forwardRef(({ className, deviceOrderCartItems = [], deviceOrderCartTotal = 0 }, ref) => {
	const confirmRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => deviceOrderCartItems,
			getTotal: () => deviceOrderCartTotal,
			isError: () => refIsRequiredError(confirmRef),
		}),
		[deviceOrderCartItems, deviceOrderCartTotal],
	);

	return (
		<Card className={clsx("order-cart batch-device-order", className)}>
			<Card.CardContent>
				{/* 標題和說明 */}
				<Box className="px-4 py-2">
					<Typography variant="h5" className="font-weight-bold">
						智能月費訂單（批次扣款）
					</Typography>
				</Box>

				{/* 購物車內容 */}
				<Box className="order-cart-content">
					<OrderCartList cartItems={deviceOrderCartItems} cartTotal={deviceOrderCartTotal} readOnly={true} showDiscount={false} />
				</Box>
				<Box className="cart-actions">
					<CheckboxField ref={confirmRef} required>
						<CheckboxField.Checkbox label="我已通知會員：因已訂閱智能系統，系統將在收取會籍月費時，自動扣款收取智能月費。" value={true} />
					</CheckboxField>
				</Box>
			</Card.CardContent>
		</Card>
	);
});

BatchDeviceOrderCart.displayName = "BatchDeviceOrderCart";

export default BatchDeviceOrderCart;
